import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RestorePageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"restore_page"}/>
}
